import moment from "moment";

export function dateFormat(date, format = "") {
  let fText = "MMMM Do YYYY, h:mm:ss a";
  if (format === "full") {
    fText = "MMMM Do YYYY, h:mm a";
  } else if (format === "date") {
    fText = "MMMM Do YYYY";
  } else if (format === "fhour") {
    fText = "h:mm:ss a";
  } else if (format === "hour") {
    fText = "h:mm";
  } else {
    fText = format;
  }
  return moment(date).format(fText);
}

export function getTotalPages(total, per_page) {
  return Math.ceil(total / per_page);
}

export function makeItSelectable(data, custom) {
  if (data?.length > 0) {
    return data.map((item) => {
      let obj = { value: item?.id, label: item?.name };
      if (custom) obj[custom] = item[custom];
      return obj;
    });
  } else return [];
}

export function parseJSON(string) {
  try {
    return JSON.parse(string);
  } catch (error) {
    return "";
  }
}

export function priceFormat(price) {
  return Number(price).toLocaleString("en-US");
}

export function getCurrentDate() {
  return new Date().toISOString().slice(0, 10);
}

// CSV Export Utilities
export function convertToCSV(data, headers) {
  if (!data || data.length === 0) return '';
  
  // Create header row
  const headerRow = headers.map(h => `"${h.label}"`).join(',');
  
  // Create data rows
  const dataRows = data.map(item => {
    return headers.map(header => {
      let value = '';
      
      // Support nested accessor (e.g., "user.name")
      if (header.accessor) {
        const keys = header.accessor.split('.');
        value = keys.reduce((obj, key) => obj?.[key], item);
      }
      
      // Format value
      if (value === null || value === undefined) {
        value = '';
      } else if (typeof value === 'object') {
        value = JSON.stringify(value);
      } else {
        value = String(value);
      }
      
      // Escape quotes and wrap in quotes
      value = value.replace(/"/g, '""');
      return `"${value}"`;
    }).join(',');
  });
  
  return [headerRow, ...dataRows].join('\n');
}

export function downloadCSV(csvContent, filename = 'export.csv') {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    // Create a link to the file
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

export function exportOrdersToCSV(orders) {
  const headers = [
    { label: 'Order Number', accessor: 'order_number' },
    { label: 'Order ID', accessor: 'id' },
    { label: 'Customer Name', accessor: 'billing_name' },
    { label: 'Customer Phone', accessor: 'billing_phone' },
    { label: 'Customer Email', accessor: 'billing_email' },
    { label: 'Status', accessor: 'status' },
    { label: 'Payment Method', accessor: 'payment_method' },
    { label: 'Delivery Fee', accessor: 'delivery_price' },
    { label: 'Summary Price', accessor: 'summary_price' },
    { label: 'Total Amount', accessor: 'total_amount' },
    { label: 'Coupon Code', accessor: 'coupon_code' },
    { label: 'Discount Amount', accessor: 'discount_amount' },
    { label: 'Shipping Address', accessor: 'shipping_address' },
    { label: 'Shipping City', accessor: 'shipping_city' },
    { label: 'Shipping Region', accessor: 'shipping_region' },
    { label: 'Order Request', accessor: 'order_request_status' },
    { label: 'Created At', accessor: 'created_at' },
    { label: 'Updated At', accessor: 'updated_at' },
  ];
  
  const csvContent = convertToCSV(orders, headers);
  const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
  const filename = `orders_export_${timestamp}.csv`;
  
  downloadCSV(csvContent, filename);
}

export function exportUsersToCSV(users) {
  const headers = [
    { label: 'User ID', accessor: 'id' },
    { label: 'Name', accessor: 'name' },
    { label: 'Full Name', accessor: 'full_name' },
    { label: 'Email', accessor: 'email' },
    { label: 'Phone', accessor: 'phone' },
    { label: 'Status', accessor: 'status' },
    { label: 'Email Verified', accessor: 'email_verified_at' },
    { label: 'Phone Verified', accessor: 'phone_verified_at' },
    { label: 'Total Orders', accessor: 'total_orders' },
    { label: 'Total Spent', accessor: 'total_spent' },
    { label: 'City', accessor: 'city.name' },
    { label: 'Township', accessor: 'township.name' },
    { label: 'Address', accessor: 'address' },
    { label: 'Created At', accessor: 'created_at' },
    { label: 'Updated At', accessor: 'updated_at' },
  ];
  
  const csvContent = convertToCSV(users, headers);
  const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
  const filename = `users_export_${timestamp}.csv`;
  
  downloadCSV(csvContent, filename);
}
